import React from 'react';
import './MVPDevelopment.css';
import Footer from '../components/home/Footer';

const MVPDevelopment = () => {
  return (
    <div className="mvp-container">
      <div className="mvp-inner">
        {/* Header Section */}
        <div className="mvp-header">
          <h1>MVP Development Service</h1>
          <p>Turn your startup idea into reality with our expert MVP development service</p>
        </div>

        {/* Main Content */}
        <div className="mvp-content">
          <div className="mvp-card">
            <div className="mvp-card-header">
              <h2>What We Offer</h2>
            </div>
            <div className="mvp-card-body">
              <p>We provide comprehensive MVP (Minimum Viable Product) development services designed specifically for startups. Our experienced team will help you build a functional, market-ready product that validates your business idea.</p>
            </div>
          </div>

          {/* Pricing & Timeline */}
          <div className="mvp-pricing-section">
            <div className="mvp-pricing-card">
              <h3>Budget</h3>
              <p className="pricing-amount">$3,000 ~ $10,000</p>
              <p className="pricing-description">Flexible pricing based on project scope and complexity</p>
            </div>

            <div className="mvp-pricing-card">
              <h3>Timeline</h3>
              <p className="pricing-amount">15 ~ 30 Days</p>
              <p className="pricing-description">Fast-track development to get your MVP to market quickly</p>
            </div>
          </div>

          {/* Features */}
          <div className="mvp-card">
            <div className="mvp-card-header">
              <h2>What's Included</h2>
            </div>
            <div className="mvp-card-body">
              <ul className="mvp-features-list">
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Requirements gathering and project planning</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>UI/UX design and prototyping</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Full-stack development (frontend & backend)</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Database design and implementation</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>API development and integration</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>AI-powered application development</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Blockchain and Web3 development</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Testing and quality assurance</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Deployment and launch support</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span>Post-launch support and maintenance</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Process */}
          <div className="mvp-card">
            <div className="mvp-card-header">
              <h2>Our Process</h2>
            </div>
            <div className="mvp-card-body">
              <div className="mvp-process">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <h4>Discovery</h4>
                  <p>Understand your vision, target market, and core features</p>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <h4>Design</h4>
                  <p>Create wireframes and UI/UX designs for your MVP</p>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <h4>Development</h4>
                  <p>Build your MVP with modern technologies and best practices</p>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <h4>Launch</h4>
                  <p>Deploy and launch your product to the market</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mvp-cta">
            <h2>Ready to Build Your MVP?</h2>
            <p>Let's discuss your startup idea and create a roadmap for success</p>
            <a href="/contact" className="mvp-cta-button">Get Started</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MVPDevelopment;
